var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataManagementPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 239,
    viewBox: "0 0 258 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.479 2.41847L197.535 4.76541C199.884 6.1309 203.128 -1.29396 205.775 0.199543L212.863 4.29602C218.157 7.3257 216.236 -1.50732 224.134 3.01587C233.399 8.34982 232.63 19.1031 237.924 22.1754L245.012 26.2719C247.659 27.8081 248.384 34.0808 250.733 35.4463L254.789 37.7932C255.685 38.3053 257.35 39.7135 257.35 41.5483C256.155 40.8656 224.177 22.3888 224.177 22.3888C224.177 22.3888 192.199 3.91197 191.003 3.22923C190.918 1.39435 192.583 1.90641 193.479 2.41847Z",
    fill: "#EFEFF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47943 7.41847L6.53539 9.76541C8.88358 11.1309 12.1284 3.70604 14.7754 5.19954L21.8627 9.29602C27.1568 12.3257 25.2355 3.49268 33.134 8.01587C42.3987 13.3498 41.6302 24.1031 46.9243 27.1754L54.0115 31.2719C56.6586 32.8081 57.3844 39.0808 59.7326 40.4463L63.7885 42.7932C64.6851 43.3053 66.3502 44.7135 66.3502 46.5483C65.1547 45.8656 33.1767 27.3888 33.1767 27.3888C33.1767 27.3888 1.1986 8.91197 0.00316153 8.22923C-0.0822272 6.39435 1.58285 6.90641 2.47943 7.41847Z",
    fill: "#EFEFF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.86 237.533L225.122 234.784L224.07 234.14L222.958 234.784L222.139 235.252L223.251 235.895L224.07 235.427L228.749 238.176L229.86 237.533Z",
    fill: "#59595B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M234.072 232.736L232.142 231.625C231.03 230.982 231.03 229.929 232.142 229.227C233.253 228.583 235.125 228.583 236.236 229.227L238.166 230.338C239.278 230.982 239.278 232.034 238.166 232.736C237.055 233.38 235.183 233.38 234.072 232.736ZM233.253 230.982L235.183 232.093C235.71 232.385 236.587 232.385 237.113 232.093C237.64 231.801 237.64 231.274 237.113 230.982L235.183 229.87C234.657 229.578 233.779 229.578 233.253 229.87C232.727 230.163 232.727 230.631 233.253 230.982Z",
    fill: "#C0162E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M214.302 231.742L212.372 230.631C211.26 229.987 211.26 228.935 212.372 228.233C213.483 227.589 215.355 227.589 216.466 228.233L218.396 229.344C219.508 229.987 219.508 231.04 218.396 231.742C217.285 232.386 215.472 232.386 214.302 231.742ZM213.483 229.987L215.413 231.099C215.94 231.391 216.817 231.391 217.343 231.099C217.87 230.806 217.87 230.28 217.343 229.987L215.413 228.876C214.887 228.584 214.009 228.584 213.483 228.876C212.957 229.169 212.957 229.695 213.483 229.987Z",
    fill: "#C0162E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.309 226.536L221.379 225.425C220.268 224.782 220.268 223.729 221.379 223.027C222.49 222.383 224.362 222.383 225.473 223.027L227.404 224.138C228.515 224.782 228.515 225.834 227.404 226.536C226.292 227.18 224.479 227.18 223.309 226.536ZM222.49 224.782L224.42 225.893C224.947 226.185 225.824 226.185 226.351 225.893C226.877 225.601 226.877 225.074 226.351 224.782L224.42 223.67C223.894 223.378 223.017 223.378 222.49 223.67C221.964 223.963 221.964 224.489 222.49 224.782Z",
    fill: "#C0162E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M237.172 220.921L232.434 218.172L231.323 217.529L230.27 218.172L229.451 218.64L230.563 219.283L231.323 218.815L236.061 221.564L237.172 220.921Z",
    fill: "#59595B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M208.394 225.133L203.715 222.383L202.603 221.74L201.492 222.383L200.673 222.851L201.784 223.495L202.603 223.027L207.341 225.776L208.394 225.133Z",
    fill: "#59595B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M212.605 220.336L210.675 219.225C209.564 218.581 209.564 217.529 210.675 216.827C211.786 216.183 213.658 216.183 214.769 216.827L216.7 217.938C217.811 218.581 217.811 219.634 216.7 220.336C215.588 220.98 213.717 220.98 212.605 220.336ZM211.786 218.581L213.717 219.693C214.243 219.985 215.12 219.985 215.647 219.693C216.173 219.4 216.173 218.874 215.647 218.581L213.717 217.47C213.19 217.178 212.313 217.178 211.786 217.47C211.26 217.763 211.26 218.289 211.786 218.581Z",
    fill: "#C0162E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M226.468 214.721L221.73 211.972L220.619 211.328L219.507 211.972L218.747 212.44L219.8 213.083L220.619 212.615L225.357 215.364L226.468 214.721Z",
    fill: "#59595B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M235.476 209.515L230.738 206.766L229.626 206.123L228.515 206.766L227.755 207.234L228.866 207.878L229.626 207.41L234.364 210.159L235.476 209.515Z",
    fill: "#59595B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.893 219.342L190.963 218.231C189.852 217.587 189.852 216.534 190.963 215.832C192.074 215.189 193.946 215.189 195.058 215.832L196.988 216.944C198.099 217.587 198.099 218.64 196.988 219.342C195.818 219.985 194.005 219.985 192.893 219.342ZM192.016 217.587L193.946 218.698C194.473 218.991 195.35 218.991 195.876 218.698C196.403 218.406 196.403 217.88 195.876 217.587L193.946 216.476C193.42 216.183 192.542 216.183 192.016 216.476C191.49 216.768 191.49 217.295 192.016 217.587Z",
    fill: "#C0162E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M201.901 214.136L199.971 213.025C198.86 212.381 198.86 211.328 199.971 210.627C201.083 209.983 202.954 209.983 204.066 210.627L205.996 211.738C207.107 212.381 207.107 213.434 205.996 214.136C204.885 214.779 203.013 214.779 201.901 214.136ZM201.024 212.381L202.954 213.493C203.481 213.785 204.358 213.785 204.885 213.493C205.411 213.2 205.411 212.674 204.885 212.381L202.954 211.27C202.428 210.977 201.55 210.977 201.024 211.27C200.498 211.562 200.498 212.089 201.024 212.381Z",
    fill: "#C0162E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M215.706 208.521L211.026 205.83L209.915 205.187L208.804 205.83L207.985 206.24L209.096 206.883L209.915 206.415L214.594 209.164L215.706 208.521Z",
    fill: "#59595B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M219.917 203.724L217.987 202.613C216.875 201.97 216.875 200.917 217.987 200.215C219.098 199.572 220.97 199.572 222.081 200.215L224.011 201.326C225.123 201.97 225.123 203.023 224.011 203.724C222.9 204.368 221.028 204.368 219.917 203.724ZM219.098 201.97L221.028 203.081C221.555 203.373 222.432 203.373 222.958 203.081C223.485 202.789 223.485 202.262 222.958 201.97L221.028 200.858C220.502 200.566 219.624 200.566 219.098 200.858C218.571 201.151 218.571 201.677 219.098 201.97Z",
    fill: "#C0162E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M228.924 198.519L226.994 197.407C225.883 196.764 225.883 195.711 226.994 195.009C228.105 194.366 229.977 194.366 231.089 195.009L233.019 196.121C234.13 196.764 234.13 197.817 233.019 198.519C231.907 199.162 230.094 199.162 228.924 198.519ZM228.106 196.764L230.036 197.875C230.562 198.168 231.44 198.168 231.966 197.875C232.492 197.583 232.492 197.056 231.966 196.764L230.036 195.653C229.509 195.36 228.632 195.36 228.106 195.653C227.579 195.945 227.579 196.471 228.106 196.764Z",
    fill: "#C0162E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M182.131 213.142L180.201 212.03C179.09 211.387 179.09 210.334 180.201 209.632C181.313 208.989 183.184 208.989 184.296 209.632L186.226 210.743C187.337 211.387 187.337 212.44 186.226 213.142C185.114 213.785 183.301 213.785 182.131 213.142ZM181.313 211.387L183.243 212.498C183.769 212.791 184.647 212.791 185.173 212.498C185.699 212.206 185.699 211.679 185.173 211.387L183.243 210.276C182.716 209.983 181.839 209.983 181.313 210.276C180.786 210.627 180.786 211.094 181.313 211.387Z",
    fill: "#C0162E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M195.994 207.526L191.256 204.836L190.145 204.192L189.033 204.836L188.273 205.304L189.384 205.889L190.145 205.479L194.883 208.17L195.994 207.526Z",
    fill: "#59595B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M200.205 202.73L198.275 201.619C197.164 200.975 197.164 199.922 198.275 199.221C199.386 198.577 201.258 198.577 202.369 199.221L204.3 200.332C205.411 200.975 205.411 202.028 204.3 202.73C203.13 203.374 201.316 203.374 200.205 202.73ZM199.328 200.975L201.258 202.087C201.784 202.379 202.662 202.379 203.188 202.087C203.715 201.794 203.715 201.268 203.188 200.975L201.258 199.864C200.732 199.572 199.854 199.572 199.328 199.864C198.801 200.215 198.801 200.683 199.328 200.975Z",
    fill: "#C0162E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M214.009 197.115L209.271 194.424L208.218 193.781L207.107 194.424L206.288 194.892L207.399 195.477L208.218 195.068L212.898 197.758L214.009 197.115Z",
    fill: "#59595B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M223.017 191.909L218.338 189.219L217.226 188.575L216.115 189.219L215.296 189.687L216.407 190.271L217.226 189.862L221.906 192.553L223.017 191.909Z",
    fill: "#59595B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M227.228 187.113L225.298 186.002C224.187 185.358 224.187 184.305 225.298 183.603C226.409 182.96 228.281 182.96 229.393 183.603L231.323 184.715C232.434 185.358 232.434 186.411 231.323 187.113C230.211 187.756 228.34 187.756 227.228 187.113ZM226.409 185.358L228.34 186.469C228.866 186.762 229.743 186.762 230.27 186.469C230.796 186.177 230.796 185.651 230.27 185.358L228.34 184.247C227.813 183.954 226.936 183.954 226.409 184.247C225.883 184.598 225.883 185.066 226.409 185.358Z",
    fill: "#C0162E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M176.224 206.532L171.544 203.842L170.433 203.198L169.322 203.842L168.503 204.31L169.614 204.953L170.433 204.485L175.112 207.176L176.224 206.532Z",
    fill: "#59595B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M180.435 201.736L178.505 200.624C177.394 199.981 177.394 198.928 178.505 198.226C179.616 197.583 181.488 197.583 182.599 198.226L184.53 199.337C185.641 199.981 185.641 201.034 184.53 201.736C183.418 202.438 181.546 202.438 180.435 201.736ZM179.616 199.981L181.546 201.092C182.073 201.385 182.95 201.385 183.477 201.092C184.003 200.8 184.003 200.273 183.477 199.981L181.546 198.87C181.02 198.577 180.143 198.577 179.616 198.87C179.09 199.221 179.09 199.688 179.616 199.981Z",
    fill: "#C0162E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M189.443 196.53L187.513 195.419C186.401 194.775 186.401 193.722 187.513 193.021C188.624 192.377 190.496 192.377 191.607 193.021L193.537 194.132C194.649 194.775 194.649 195.828 193.537 196.53C192.426 197.232 190.613 197.232 189.443 196.53ZM188.624 194.775L190.554 195.887C191.081 196.179 191.958 196.179 192.485 195.887C193.011 195.594 193.011 195.068 192.485 194.775L190.554 193.664C190.028 193.372 189.15 193.372 188.624 193.664C188.098 194.015 188.098 194.483 188.624 194.775Z",
    fill: "#C0162E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M198.45 191.324L196.52 190.213C195.409 189.57 195.409 188.517 196.52 187.815C197.631 187.171 199.503 187.171 200.614 187.815L202.545 188.926C203.656 189.57 203.656 190.622 202.545 191.324C201.433 192.026 199.62 192.026 198.45 191.324ZM197.631 189.57L199.562 190.681C200.088 190.973 200.965 190.973 201.492 190.681C202.018 190.388 202.018 189.862 201.492 189.57L199.562 188.458C199.035 188.166 198.158 188.166 197.631 188.458C197.105 188.809 197.105 189.277 197.631 189.57Z",
    fill: "#C0162E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M212.313 185.709L207.575 183.018L206.464 182.375L205.353 183.018L204.592 183.486L205.704 184.13L206.464 183.662L211.202 186.352L212.313 185.709Z",
    fill: "#59595B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M216.524 180.913L214.594 179.801C213.483 179.158 213.483 178.105 214.594 177.403C215.705 176.76 217.577 176.76 218.688 177.403L220.619 178.515C221.73 179.158 221.73 180.211 220.619 180.913C219.507 181.615 217.636 181.615 216.524 180.913ZM215.647 179.158L217.577 180.269C218.104 180.562 218.981 180.562 219.507 180.269C220.034 179.977 220.034 179.45 219.507 179.158L217.577 178.047C217.051 177.754 216.173 177.754 215.647 178.047C215.12 178.398 215.12 178.866 215.647 179.158Z",
    fill: "#C0162E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M230.328 175.297L225.649 172.607L224.538 171.963L223.426 172.607L222.607 173.075L223.719 173.718L224.538 173.25L229.217 175.941L230.328 175.297Z",
    fill: "#59595B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M144.612 27.7413C148.122 30.0225 155.55 35.0528 158.592 41.7208C160.58 46.1077 161.341 53.1852 164.909 55.1739C172.103 59.0929 176.198 41.8378 185.381 46.6341C194.915 51.5475 191.756 68.9195 198.717 72.546C203.63 75.1197 204.8 62.8949 218.721 70.7328V102.611L144.788 59.8533L144.612 27.7413Z",
    fill: "url(#paint0_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M145.723 20.0789C145.723 19.377 145.255 18.4997 144.612 18.1487C144.027 17.7978 143.5 18.0902 143.5 18.7921C143.5 19.4355 143.91 20.1374 144.378 20.5469V54.2967L144.787 54.5306V20.8393C145.313 21.0148 145.723 20.7224 145.723 20.0789Z",
    fill: "#292929"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M219.773 62.8365C219.773 62.1346 219.306 61.2572 218.662 60.9063C218.077 60.5553 217.551 60.8478 217.551 61.5497C217.551 62.1931 217.96 62.895 218.428 63.3044V96.9957L218.838 97.2297V63.5384C219.364 63.7724 219.773 63.4799 219.773 62.8365Z",
    fill: "#292929"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M133.616 61.2573L159.001 75.9387L70.3863 127.061L45.0009 112.438L133.616 61.2573Z",
    fill: "#C0162E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M45 112.438L70.3855 127.061V174.615L45 159.933V112.438Z",
    fill: "url(#paint1_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3855 127.061L159.001 75.9387V123.434L70.3855 174.614V127.061Z",
    fill: "url(#paint2_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6396 141.683L58.7453 142.912V145.368L56.6396 144.14V141.683Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6396 132.559L58.7453 133.787V136.244L56.6396 135.016V132.559Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6396 150.75L58.7453 151.978V154.493L56.6396 153.206V150.75Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M101.971 95.4165L99.8655 94.1882L101.971 92.9598L104.135 94.1882L101.971 95.4165Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4307 100.33L91.325 99.1014L93.4307 97.873L95.5949 99.1014L93.4307 100.33Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8911 105.302L82.7854 104.015L84.8911 102.786L87.0553 104.015L84.8911 105.302Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3517 110.215L74.1875 108.987L76.3517 107.758L78.4574 108.987L76.3517 110.215Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8118 115.128L65.6476 113.9L67.8118 112.672L69.9175 113.9L67.8118 115.128Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M136.188 75.6462L134.024 74.4179L136.188 73.1896L138.294 74.4179L136.188 75.6462Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M127.649 80.618L125.485 79.3897L127.649 78.1614L129.755 79.3897L127.649 80.618Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M119.109 85.5316L116.945 84.3032L119.109 83.0749L121.215 84.3032L119.109 85.5316Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M110.511 90.4448L108.405 89.2164L110.511 87.9881L112.675 89.2164L110.511 90.4448Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M165.26 79.5652L222.348 112.496L181.17 136.244L124.14 103.313L165.26 79.5652Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M124.139 103.313L181.169 136.244V183.798L124.139 150.867V103.313Z",
    fill: "#292929"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M181.169 136.244L222.347 112.496V160.05L181.169 183.798V136.244Z",
    fill: "#292929"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M117.823 106.939L143.208 121.621L102.03 145.369L76.6443 130.687L117.823 106.939Z",
    fill: "url(#paint3_linear)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M76.644 130.687L102.03 145.368V192.864L76.644 178.241V130.687Z",
    fill: "#59595B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M102.03 145.368L143.208 121.621V169.116L102.03 192.864V145.368Z",
    fill: "#59595B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M107.762 142.034L105.656 143.263V190.817L107.762 189.588V142.034Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M114.196 138.35L112.032 139.578V187.132L114.196 185.903V138.35Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M120.631 134.665L118.467 135.893V183.388L120.631 182.16V134.665Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M127.006 130.98L124.901 132.208V179.703L127.006 178.475V130.98Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M133.44 127.236L131.276 128.464V176.018L133.44 174.79V127.236Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M139.816 123.551L137.71 124.779V172.333L139.816 171.046V123.551Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4347 127.412L80.2705 128.64L105.656 143.263L107.762 142.035L82.4347 127.412Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8105 123.727L86.7048 124.955L112.032 139.578L114.196 138.35L88.8105 123.727Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M95.245 119.983L93.0808 121.211L118.466 135.893L120.63 134.665L95.245 119.983Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M101.621 116.298L99.5151 117.526L124.901 132.208L127.006 130.98L101.621 116.298Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M108.054 112.613L105.89 113.842L131.276 128.465L133.44 127.236L108.054 112.613Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M114.43 108.928L112.324 110.157L137.71 124.78L139.816 123.551L114.43 108.928Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2834 150.867L90.4476 152.095V154.552L88.2834 153.324V150.867Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9141 146.597L83.0198 147.825V150.282L80.9141 149.054V146.597Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6533 155.137L97.8175 156.365V158.822L95.6533 157.593V155.137Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2834 169.058L90.4476 170.286V172.743L88.2834 171.515V169.058Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9136 164.788L83.0193 166.016V168.473L80.9136 167.245V164.788Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6533 173.328L97.8175 174.556V177.013L95.6533 175.784V173.328Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M149.526 125.247L174.911 139.929L149.526 154.552L124.14 139.87L149.526 125.247Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M124.139 139.87L149.525 154.552V202.047L124.139 187.424V139.87Z",
    fill: "#292929"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M149.525 154.552L174.911 139.929V187.424L149.525 202.047V154.552Z",
    fill: "#292929"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M135.779 169.116L137.885 170.345V172.86L135.779 171.631V169.116Z",
    fill: "#59595B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M135.779 160.05L137.885 161.278V163.735L135.779 162.507V160.05Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M135.779 178.241L137.885 179.469V181.926L135.779 180.698V178.241Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M163.27 169.116L161.106 170.345V172.86L163.27 171.631V169.116Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M163.27 160.05L161.106 161.278V163.735L163.27 162.507V160.05Z",
    fill: "#C0162E"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M163.27 178.241L161.106 179.469V181.926L163.27 180.698V178.241Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M220.008 139.636C221.06 141.099 219.774 143.321 221.996 143.614C225.038 143.965 231.355 144.901 231.413 143.38C231.472 142.093 227.144 141.157 225.096 140.28C222.289 139.11 221.996 138.115 221.996 138.115L220.008 139.636Z",
    fill: "#C0162E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M221.938 138.115C221.938 138.115 222.23 139.11 225.038 140.28C225.564 140.514 226.208 140.748 226.91 140.982C226.91 140.982 227.261 141.099 227.202 141.742C227.027 142.97 221.704 142.619 220.534 141.859C220.417 141.216 220.476 140.338 220.008 139.695L221.938 138.115Z",
    fill: "#FFCEA2"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M217.493 140.455C217.551 140.923 218.37 142.444 218.897 143.204C219.365 143.848 221.119 145.953 221.295 146.187C222.114 147.006 221.529 147.767 220.3 147.767C219.072 147.767 218.253 147.708 217.668 147.357C216.849 146.889 214.042 144.9 214.217 143.672C214.334 143.029 214.451 143.029 214.685 141.508C214.744 141.098 214.802 140.104 214.802 140.104L217.493 140.455Z",
    fill: "#C0162E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M216.908 144.783C216.03 144.316 214.86 143.38 214.451 142.678C214.509 142.444 214.568 142.093 214.626 141.625C214.685 141.215 214.743 140.221 214.743 140.221L217.434 140.455C217.493 140.923 218.311 142.444 218.838 143.204C219.013 143.438 219.306 143.848 219.715 144.315C219.949 145.193 217.785 145.251 216.908 144.783Z",
    fill: "#FFCEA2"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M209.128 120.743C207.491 119.866 193.219 110.858 193.219 110.858L185.147 110.156C184.445 111.56 181.988 116.766 185.556 119.749C189.124 122.732 200.589 125.306 206.145 125.891L209.713 121.153C209.421 120.919 209.245 120.802 209.128 120.743Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M209.655 121.094L206.087 125.832C207.315 129.4 219.891 139.753 219.891 139.753C220.944 139.461 221.353 138.993 222.289 138.349C221.353 136.712 212.053 123.726 209.655 121.094Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M194.798 107.817C194.798 107.817 187.077 110.507 189.124 112.379C191.113 114.251 205.326 119.574 210.24 120.1L214.334 116.766C211.702 113.607 196.436 108.46 194.798 107.817Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M214.334 116.766L210.24 120.1C209.596 124.487 213.691 136.185 214.685 140.514C215.738 141.215 216.849 141.04 217.668 140.338C217.668 140.338 216.908 119.807 214.334 116.766Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M203.98 107.232C203.747 107.056 203.279 107.056 203.045 107.232L187.486 116.239C187.252 116.415 187.252 116.649 187.486 116.766L198.131 122.907C198.365 123.083 198.833 123.083 199.067 122.907L214.626 113.9C214.86 113.724 214.86 113.49 214.626 113.373L203.98 107.232Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M199.008 121.621L198.248 122.089L198.657 122.264L199.418 121.855L199.008 121.621Z",
    fill: "url(#paint4_linear)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M200.295 120.86L199.535 121.328L199.944 121.562L200.705 121.094L200.295 120.86Z",
    fill: "url(#paint5_linear)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M201.582 120.158L200.822 120.568L201.231 120.802L201.992 120.392L201.582 120.158Z",
    fill: "url(#paint6_linear)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M202.869 119.398L202.108 119.866L202.518 120.041L203.278 119.632L202.869 119.398Z",
    fill: "url(#paint7_linear)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M204.155 118.638L203.395 119.106L203.804 119.339L204.565 118.872L204.155 118.638Z",
    fill: "url(#paint8_linear)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M205.443 117.936L204.682 118.345L205.092 118.579L205.852 118.111L205.443 117.936Z",
    fill: "url(#paint9_linear)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M206.729 117.175L205.969 117.643L206.378 117.819L207.139 117.409L206.729 117.175Z",
    fill: "url(#paint10_linear)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M208.016 116.415L207.255 116.883L207.665 117.117L208.425 116.649L208.016 116.415Z",
    fill: "url(#paint11_linear)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M209.302 115.713L208.542 116.122L208.893 116.356L209.653 115.888L209.302 115.713Z",
    fill: "url(#paint12_linear)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M210.589 114.953L209.829 115.421L210.18 115.596L210.94 115.187L210.589 114.953Z",
    fill: "url(#paint13_linear)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M211.876 114.192L211.115 114.66L211.466 114.894L212.227 114.426L211.876 114.192Z",
    fill: "url(#paint14_linear)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M213.163 113.49L212.403 113.9L212.754 114.134L213.514 113.666L213.163 113.49Z",
    fill: "url(#paint15_linear)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M198.366 120.509L196.962 121.328L197.722 121.738L199.126 120.977L198.366 120.509Z",
    fill: "url(#paint16_linear)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M197.663 119.515L195.733 120.626L196.493 121.036L198.424 119.983L197.663 119.515Z",
    fill: "url(#paint17_linear)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M196.902 118.462L194.446 119.866L195.206 120.334L197.663 118.93L196.902 118.462Z",
    fill: "url(#paint18_linear)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M194.271 118.17L192.925 118.988L193.978 119.573L195.323 118.754L194.271 118.17Z",
    fill: "url(#paint19_linear)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M196.201 117.117L194.797 117.877L195.85 118.462L197.195 117.702L196.201 117.117Z",
    fill: "url(#paint20_linear)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M198.073 116.005L196.727 116.766L197.722 117.409L199.125 116.59L198.073 116.005Z",
    fill: "url(#paint21_linear)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M204.623 112.262L203.219 113.022L204.272 113.607L205.618 112.847L204.623 112.262Z",
    fill: "url(#paint22_linear)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M207.782 110.39L205.092 111.911L206.144 112.554L208.835 110.975L207.782 110.39Z",
    fill: "url(#paint23_linear)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M202.694 113.315L198.599 115.713L199.652 116.298L203.746 113.9L202.694 113.315Z",
    fill: "url(#paint24_linear)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M200.002 119.573L198.891 120.217L199.652 120.685L200.763 120.041L200.002 119.573Z",
    fill: "url(#paint25_linear)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M199.301 118.579L198.189 119.222L198.95 119.69L200.061 118.988L199.301 118.579Z",
    fill: "url(#paint26_linear)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M198.541 117.526L197.429 118.228L198.19 118.637L199.301 117.994L198.541 117.526Z",
    fill: "url(#paint27_linear)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M200.178 116.59L199.067 117.234L199.827 117.702L200.939 117.058L200.178 116.59Z",
    fill: "url(#paint28_linear)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M201.874 115.654L200.705 116.298L201.465 116.766L202.635 116.122L201.874 115.654Z",
    fill: "url(#paint29_linear)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M203.512 114.719L202.342 115.362L203.161 115.771L204.272 115.128L203.512 114.719Z",
    fill: "url(#paint30_linear)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M205.15 113.783L204.039 114.426L204.799 114.836L205.911 114.192L205.15 113.783Z",
    fill: "url(#paint31_linear)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M206.788 112.788L205.676 113.432L206.437 113.9L207.548 113.256L206.788 112.788Z",
    fill: "url(#paint32_linear)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M209.361 111.326L207.314 112.496L208.074 112.964L210.18 111.735L209.361 111.326Z",
    fill: "url(#paint33_linear)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M200.939 117.643L199.827 118.286L200.588 118.696L201.699 118.052L200.939 117.643Z",
    fill: "url(#paint34_linear)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M202.576 116.649L201.465 117.351L202.225 117.76L203.337 117.117L202.576 116.649Z",
    fill: "url(#paint35_linear)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M204.214 115.713L203.103 116.356L203.863 116.824L204.975 116.181L204.214 115.713Z",
    fill: "url(#paint36_linear)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M205.852 114.777L204.74 115.42L205.501 115.888L206.612 115.245L205.852 114.777Z",
    fill: "url(#paint37_linear)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M207.49 113.841L206.378 114.485L207.139 114.894L208.25 114.251L207.49 113.841Z",
    fill: "url(#paint38_linear)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M210.648 112.028L208.016 113.549L208.776 113.958L211.408 112.437L210.648 112.028Z",
    fill: "url(#paint39_linear)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M201.641 118.638L200.53 119.281L201.29 119.749L202.401 119.105L201.641 118.638Z",
    fill: "url(#paint40_linear)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M203.278 117.702L202.167 118.345L202.927 118.755L204.038 118.111L203.278 117.702Z",
    fill: "url(#paint41_linear)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M204.916 116.766L203.805 117.409L204.565 117.819L205.676 117.175L204.916 116.766Z",
    fill: "url(#paint42_linear)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M206.554 115.771L205.443 116.415L206.204 116.883L207.315 116.239L206.554 115.771Z",
    fill: "url(#paint43_linear)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M208.192 114.835L207.081 115.479L207.841 115.947L208.952 115.303L208.192 114.835Z",
    fill: "url(#paint44_linear)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M209.83 113.9L208.718 114.543L209.479 114.953L210.648 114.309L209.83 113.9Z",
    fill: "url(#paint45_linear)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M211.877 112.73L210.356 113.607L211.116 114.017L212.637 113.198L211.877 112.73Z",
    fill: "url(#paint46_linear)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M212.579 114.66L200.296 121.738L200.647 121.972L212.988 114.836L212.579 114.66Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M202.694 112.379L196.435 116.064L192.516 113.783L198.775 110.156L202.694 112.379Z",
    fill: "url(#paint47_linear)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M187.486 116.766L198.132 122.907C198.307 123.024 198.658 123.024 198.892 122.966L199.067 122.907L214.626 113.9C214.626 113.9 214.685 113.9 214.685 113.841C214.685 113.841 214.685 113.841 214.685 113.783C214.685 113.724 214.743 113.724 214.743 113.666V113.9C214.743 114.017 214.685 114.075 214.568 114.192L199.009 123.141C198.658 123.317 198.132 123.317 197.956 123.258C197.781 123.2 197.664 123.2 197.488 123.141L187.486 117.351C187.369 117.292 187.311 117.175 187.311 117.058V116.473C187.252 116.59 187.311 116.707 187.486 116.766Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M195.032 77.5178C197.079 80.5009 197.488 87.2275 195.617 91.5559C194.213 91.5559 191.99 89.6256 189.943 90.3275C189.416 90.503 192.458 77.5178 195.032 77.5178Z",
    fill: "#F2C94C"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M203.748 108.168C204.801 108.753 207.14 109.103 207.784 109.688C208.427 110.273 208.603 112.028 208.076 112.554C207.55 113.081 207.023 113.081 207.316 112.554C207.608 112.028 207.55 110.975 206.731 110.917C205.21 110.741 207.14 112.438 206.38 112.496C205.678 112.496 205.386 111.619 204.567 111.034C203.748 110.39 203.163 110.215 202.402 109.513C201.701 108.869 203.748 108.168 203.748 108.168Z",
    fill: "#FACFA7"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M204.04 108.285C202.753 107.407 198.717 103.547 197.956 102.26C197.313 101.09 196.202 94.422 196.085 93.6031C196.026 92.7257 195.441 89.1577 191.99 89.3332C191.639 91.6729 194.622 102.728 195.734 104.19C197.137 105.945 201.173 108.636 202.402 109.454C203.747 108.928 204.04 108.285 204.04 108.285Z",
    fill: "#FFCEA2"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M218.428 106.822L203.396 115.479C203.162 115.596 202.928 115.83 202.811 116.064L198.95 122.615C198.892 122.732 199.009 122.849 199.126 122.791L214.802 113.783C214.919 113.724 215.036 113.607 215.094 113.49L218.721 107.349C219.013 106.881 218.838 106.647 218.428 106.822Z",
    fill: "#292929"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M198.95 122.674L202.811 116.123C202.928 115.889 203.162 115.655 203.396 115.538L218.428 106.881C218.604 106.764 218.721 106.764 218.779 106.881C218.779 106.881 218.662 106.764 218.545 106.647C218.487 106.588 218.37 106.588 218.194 106.647L203.162 115.304C202.928 115.421 202.694 115.655 202.577 115.889L198.716 122.44C198.658 122.498 198.716 122.557 198.716 122.615C198.775 122.674 198.892 122.791 198.892 122.791C198.892 122.791 198.892 122.732 198.95 122.674Z",
    fill: "#292929"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M185.088 109.455C185.673 104.307 183.333 97.9901 182.865 94.7731C182.573 92.7259 182.397 90.3277 184.211 89.7428C186.141 89.1579 186.901 88.8654 188.539 88.9239C192.516 89.0409 194.388 89.8598 195.207 92.6089C195.968 95.1825 196.494 96.0014 197.137 98.5166C197.43 99.6279 194.564 103.137 194.915 108.051C196.084 112.555 183.684 113.257 185.088 109.455Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M187.194 84.1275C187.253 82.8991 191.464 85.3558 191.347 86.9351C191.289 88.2804 191.113 89.5672 191.581 89.7427C192.166 90.1521 193.102 92.9013 192.107 93.9541C188.539 92.4918 187.428 91.0295 184.27 89.8012C185.556 89.5087 186.96 88.1049 187.194 84.1275Z",
    fill: "#FFCEA2"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M196.435 113.023C198.015 114.134 198.483 113.432 199.301 113.841C200.179 114.251 200.998 114.836 201.29 115.011C201.583 115.187 200.588 115.187 200.179 115.011C201.173 115.83 201.232 116.883 201.056 117.351C200.822 117.877 199.477 118.404 199.126 118.111C197.781 116.824 198.015 116.357 196.201 115.83C195.558 115.655 194.622 114.719 194.622 114.719L196.435 113.023Z",
    fill: "#FACFA7"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M196.435 113.022C193.978 111.56 189.358 106.179 188.948 104.19C188.597 102.201 186.433 90.0937 183.625 90.3276C180.876 90.5616 184.21 102.026 186.14 106.237C187.076 108.285 191.814 113.139 194.622 114.719C195.733 114.777 196.435 113.022 196.435 113.022Z",
    fill: "#FFCEA2"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M186.141 82.4313L187.427 79.2728L193.862 78.2784C193.862 78.2784 194.271 78.0444 194.973 78.0444C195.967 80.0332 195.441 84.1276 195.441 84.1276C195.441 86.7597 193.628 88.9239 191.463 88.9239C189.299 88.9239 187.603 86.8767 187.486 84.3616H186.901L186.141 82.4313Z",
    fill: "#FFCEA2"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M188.129 86.7598C188.831 87.9881 189.942 88.807 191.229 88.8655C191.229 89.2749 191.287 89.5089 191.463 89.6844C191.229 89.6844 191.054 89.6844 190.82 89.6259C189.474 89.2749 188.538 88.1636 188.129 86.7598Z",
    fill: "#FBC096"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M191.112 75.7631C184.97 75.7631 183.8 83.3085 182.748 89.8596C183.683 91.9068 185.965 93.4276 188.772 94.1295C192.106 94.4805 187.661 83.0161 192.34 80.033C193.627 79.2141 196.025 79.565 195.557 78.5122C194.504 76.1725 193.218 75.7631 191.112 75.7631Z",
    fill: "#F2C94C"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3064 217.077L75.6986 209.35V193.726L62.3064 201.367V217.077Z",
    fill: "#292929"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3063 217.077L49 209.35V193.726L62.3063 201.367V217.077Z",
    fill: "#313131"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3063 201.367L49 193.726L62.3063 186L75.6985 193.726L62.3063 201.367Z",
    fill: "#313131"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4568 193.726L62.306 190.722L57.241 193.726L62.306 196.645L67.4568 193.726Z",
    fill: "url(#paint48_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 174.7,
    y1: 77.2141,
    x2: 190.64,
    y2: 49.6058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196181,
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 57.6469,
    y1: 174.615,
    x2: 57.6469,
    y2: 112.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 114.533,
    y1: 174.614,
    x2: 114.533,
    y2: 75.9387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 143.208,
    y1: 122.893,
    x2: 100.796,
    y2: 190.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 198.833,
    y1: 121.621,
    x2: 198.833,
    y2: 122.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 200.12,
    y1: 120.86,
    x2: 200.12,
    y2: 121.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 201.407,
    y1: 120.158,
    x2: 201.407,
    y2: 120.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 202.693,
    y1: 119.398,
    x2: 202.693,
    y2: 120.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 203.98,
    y1: 118.638,
    x2: 203.98,
    y2: 119.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 205.267,
    y1: 117.936,
    x2: 205.267,
    y2: 118.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 206.554,
    y1: 117.175,
    x2: 206.554,
    y2: 117.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 207.84,
    y1: 116.415,
    x2: 207.84,
    y2: 117.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 209.098,
    y1: 115.713,
    x2: 209.098,
    y2: 116.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 210.385,
    y1: 114.953,
    x2: 210.385,
    y2: 115.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 211.671,
    y1: 114.192,
    x2: 211.671,
    y2: 114.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 212.959,
    y1: 113.49,
    x2: 212.959,
    y2: 114.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 198.044,
    y1: 120.509,
    x2: 198.044,
    y2: 121.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 197.078,
    y1: 119.515,
    x2: 197.078,
    y2: 121.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 196.054,
    y1: 118.462,
    x2: 196.054,
    y2: 120.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 194.124,
    y1: 118.17,
    x2: 194.124,
    y2: 119.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 195.996,
    y1: 117.117,
    x2: 195.996,
    y2: 118.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 197.926,
    y1: 116.005,
    x2: 197.926,
    y2: 117.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 204.419,
    y1: 112.262,
    x2: 204.419,
    y2: 113.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 206.963,
    y1: 110.39,
    x2: 206.963,
    y2: 112.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 201.173,
    y1: 113.315,
    x2: 201.173,
    y2: 116.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 199.827,
    y1: 119.573,
    x2: 199.827,
    y2: 120.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 199.125,
    y1: 118.579,
    x2: 199.125,
    y2: 119.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 198.365,
    y1: 117.526,
    x2: 198.365,
    y2: 118.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 200.003,
    y1: 116.59,
    x2: 200.003,
    y2: 117.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 201.67,
    y1: 115.654,
    x2: 201.67,
    y2: 116.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 203.307,
    y1: 114.719,
    x2: 203.307,
    y2: 115.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 204.975,
    y1: 113.783,
    x2: 204.975,
    y2: 114.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 206.612,
    y1: 112.788,
    x2: 206.612,
    y2: 113.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 208.747,
    y1: 111.326,
    x2: 208.747,
    y2: 112.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 200.763,
    y1: 117.643,
    x2: 200.763,
    y2: 118.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 202.401,
    y1: 116.649,
    x2: 202.401,
    y2: 117.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 204.039,
    y1: 115.713,
    x2: 204.039,
    y2: 116.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 205.676,
    y1: 114.777,
    x2: 205.676,
    y2: 115.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 207.314,
    y1: 113.841,
    x2: 207.314,
    y2: 114.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 209.712,
    y1: 112.028,
    x2: 209.712,
    y2: 113.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 201.465,
    y1: 118.638,
    x2: 201.465,
    y2: 119.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 203.103,
    y1: 117.702,
    x2: 203.103,
    y2: 118.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 204.741,
    y1: 116.766,
    x2: 204.741,
    y2: 117.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 206.379,
    y1: 115.771,
    x2: 206.379,
    y2: 116.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 208.016,
    y1: 114.835,
    x2: 208.016,
    y2: 115.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 209.683,
    y1: 113.9,
    x2: 209.683,
    y2: 114.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 211.497,
    y1: 112.73,
    x2: 211.497,
    y2: 114.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 197.605,
    y1: 110.156,
    x2: 197.605,
    y2: 116.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 62.3489,
    y1: 190.722,
    x2: 62.3489,
    y2: 196.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataManagementPreview);
export default __webpack_public_path__ + "static/media/data_management_preview.780d25f39285058b8eacd4fd90b76d91.svg";
export { ForwardRef as ReactComponent };